// すべて外部チャットへ移行
/*
const getButtonImage = (id) => `${process.env.PUBLIC_URL}/images/button/${id}.png`

const getAvatar = (id) => `${process.env.PUBLIC_URL}/images/avatar/${id}.png`
*/

const categories = {
/*
  19: {
    name: 'ごみ',
    buttonImage: getButtonImage(19),
    guideTexts: [
      'こんにちは。\n' +
        '葛飾区ごみ減量ボットだよ！\n' +
        'ごみの名前を教えてくれたら、出し方を案内するよ。\n' +
        '（注意）応答履歴は、２４時間経過すると削除されます。',
    ],
    botUser: {
      name: '葛飾区',
      avatar: getAvatar(19),
    },
  },
  20: {
    name: '戸籍・住民登録',
    buttonImage: getButtonImage(20),
    guideTexts: [
      'こんにちは。\n' +
        '戸籍や住民票などに関する各種証明書の申請手続き、転入・転出・転居の手続き、婚姻届に関することなどの質問にお答えします。\n' +
        '（例）区外から葛飾区に引越しました。どうすればいいのですか。\n' +
        '（注意）応答履歴は、２４時間経過すると削除されます。',
    ],
    botUser: {
      name: '葛飾区',
      avatar: getAvatar(20),
    },
  },
*/
}

export default categories
